export const GENERATE_PASSPORT_BACKGROUND_WITH_AI_TEXT = {
    id: 'oe.passport.generatePassportBackgroundWithAiText',
    description: 'Label text',
    defaultMessage: 'Generate Image with AI'
};

export const GENERATE_PASSPORT_BACKGROUND_BUTTON_TEXT = {
    id: 'oe.passport.generatePassportBackgroundButtonText',
    description: 'Label text',
    defaultMessage: 'Generate with AI'
};

export const PROMPT_TEXT_AREA_LABEL_TEXT = {
    id: 'oe.passport.promptTextAreaLabel',
    description: 'Label text',
    defaultMessage: 'Text Prompt'
};

export const GENERATE_PASSPORT_BACKGROUND_LOADING_TITLE_TEXT = {
    id: 'oe.passport.generatePassportBackgroundLoadingTitleText',
    description: 'Label text',
    defaultMessage: 'Generating AI image from text prompt...'
};

export const GENERATE_PASSPORT_BACKGROUND_LOADING_INFO_TEXT = {
    id: 'oe.passport.generatePassportBackgroundLoadingInfoText',
    description: 'Label text',
    defaultMessage: 'This usually takes around 20 seconds.'
};

export const GENERATE_PASSPORT_BACKGROUND_INPUT_TEXT = {
    id: 'oe.passport.generatePassportBackgroundInputText',
    description: 'Label text',
    defaultMessage: `Please describe in words the image you wish to generate.{br}
    Adding details will lead to a more accurate result.
    `
};

export const USE_IMAGE_BUTTON_TEXT = {
    id: 'oe.passport.useImage',
    description: 'Label text',
    defaultMessage: 'Use Image'
};

export const TRY_AGAIN_TEXT = {
    id: 'oe.passport.tryAgain',
    description: 'Label text',
    defaultMessage: 'Try Again'
};